import { emailValidationRegex, urlValidationRegex } from "../app_methods";
import { post } from "../services/HttpService";

export class InstaCollectSettingsModel {
  static emailValidator(_rule, values, callback, required) {
    // if (!required) return callback();
    
    const emailRegex = emailValidationRegex();
    const invalidInputs = values.filter((value) => !value.match(emailRegex));
    if (invalidInputs.length === 0) {
      callback();
    } else if (invalidInputs.length === 1) {
      callback(invalidInputs.join("") + " is not a valid email");
    } else {
      callback(
        invalidInputs.slice(0, -1).join(", ") +
          " and " +
          invalidInputs.slice(-1) +
          " are not valid emails"
      );
    }
  }

  static phoneNumberValidator = (_rule, values, callback, required) => {
    // if (!required) return callback();

    const mobileRegex = /^[2-9]{1}\d{9}$/;
    const invalidInputs = values.filter((value) => !value.match(mobileRegex));
    if (invalidInputs.length === 0) {
      callback();
    } else if (invalidInputs.length === 1) {
      callback(invalidInputs.join("") + " is not a valid phone number");
    } else {
      callback(
        invalidInputs.slice(0, -1).join(", ") +
          " and " +
          invalidInputs.slice(-1) +
          " are not valid phone number"
      );
    }
  };

  static webhookUrlValidator = (_rule, value, callback, required) => {
    if (!required || !value) return callback();

    const regex = urlValidationRegex()
    if (!regex.test(value)) {
      callback("Invalid input");
    } else {
      callback();
    }
  };

  static webhookMaxAttemptsvalidator = (_rule, value, callback, required) => {
    if (!required || !value) return callback();

    const regex = /^[1-9][0-9]*$/;
    if (!regex.test(value)) {
      callback("Invalid input");
    } else if (value < 2 || value > 9) {
      callback("Max attempts must be between 2 to 9");
    } else {
      callback();
    }
  };

  static validations = {
    email: (required) => {
      return [
        {
          required,
          message: "Please enter email id",
        },
        {
          validator: (rule, values, callback) =>
            this.emailValidator(rule, values, callback, required),
        },
      ];
    },
    phone: (required) => {
      return [
        {
          required,
          message: "Please enter phone number",
        },
        {
          validator: (rule, values, callback) =>
            this.phoneNumberValidator(rule, values, callback, required),
        },
      ];
    },
    webhook_url: (required) => {
      return [
        {
          required,
          message: "Webhook url is required.",
        },
        {
          validator: (rule, value, callback) =>
            this.webhookUrlValidator(rule, value, callback, required),
        },
      ];
    },
    transaction_capture_attempts: (required) => {
      return [
        {
          required,
          message: "Max attempts required.",
        },
        {
          validator: (rule, value, callback) =>
            this.webhookMaxAttemptsvalidator(rule, value, callback, required),
        },
      ];
    },
  };

  static update_settings = (queryData = {}) => {
    return post(
      `v1/insta-collect/internal/master_virtual_accounts/settings/`,
      queryData
    );
  };

  static update_qr_logo = (queryData = {}) => {
    let formData = new FormData();
    if(queryData.file) {
      const fileBlob = new Blob([queryData.file.file], { type: queryData.file.file.type });
      formData.append('file',fileBlob)
    };
    formData.append('update_for_all_submerchants',queryData.update_for_all_submerchants || false);
    formData.append('update_for_all_cva',queryData.update_for_all_cva || false);

    return post(
      `v1/smart-collect/internal/virtual_accounts/update_logo/`,
      formData, {}
    );
  };
}
